import { IM360Parser } from '../../IM360Parser'

function noticeWonder(description?: string): description is string {
  return !!description?.includes('notice?') && description.includes('wonder?')
}

export function parseNoticeWonder({
  title,
  statement,
  studentResponse,
}: {
  title?: string
  statement?: string
  studentResponse?: string
}) {
  if (!noticeWonder(statement)) return
  return [
    IM360Parser.getInstance().createShortResponse({
      title,
      description: statement,
      teacherNote: studentResponse,
    }),
  ]
}
